import React from 'react';
import { useNavigate } from 'react-router-dom';
import { forceUrbaniaRoutes } from '../../../data/forceUrbaniaRoutes';
import { Icon } from '@iconify/react';

const ForceUrbaniaRoutes = () => {
  const navigate = useNavigate();

  const getAllUrbaniaRoutes = () => {
    const routes = [];
    const routeKeys = Object.keys(forceUrbaniaRoutes);
    
    routeKeys?.forEach(key => {
      const route = forceUrbaniaRoutes?.[key];
      if (route?.from && route?.to && route?.fareStart) {
        routes?.push({
          id: key,
          from: route?.from,
          to: route?.to,
          slug: key,
          image: route?.image || route?.vehicles?.[0]?.image || "https://img.rocket.new/generatedImages/rocket_gen_img_18ecbb159-1768520248568.png",
          alt: route?.alt || route?.vehicles?.[0]?.imageAlt || `Force Urbania from ${route?.from} to ${route?.to}`,
          fareStart: `₹ ${route?.fareStart}/-`
        });
      }
    });
    
    return routes?.slice(0, 12);
  };

  const urbaniaRoutes = getAllUrbaniaRoutes();

  const handleBookUrbania = (route) => {
    navigate(`/force-urbania-route-booking/${route?.slug}`);
    window.scrollTo(0, 0);
  };

  return (
    <section className="py-16 bg-gradient-to-br from-purple-50 via-white to-blue-50">
      <div className="container mx-auto px-4">
        <div className="text-center mb-12 animate-fade-in-down">
          <h2 className="text-3xl md:text-4xl font-bold text-transparent bg-clip-text bg-gradient-to-r from-purple-600 via-blue-600 to-purple-600 mb-4">
            Force Urbania Routes
          </h2>
          <p className="text-gray-600 text-lg">
            Premium group travel with spacious Force Urbania vehicles
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {urbaniaRoutes?.slice(0, 8)?.map((route, index) => (
            <div
              key={index}
              onClick={() => handleBookUrbania(route)}
              className="group bg-white rounded-2xl overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-300 cursor-pointer hover-lift border-2 border-transparent hover:border-purple-400 animate-fade-in-up"
              style={{ animationDelay: `${index * 0.1}s` }}
            >
              <div className="relative h-48 overflow-hidden image-zoom">
                <img
                  src={route?.image}
                  alt={route?.alt}
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/30 to-transparent"></div>
                <div className="absolute bottom-3 left-3 right-3">
                  <h3 className="text-white font-bold text-lg mb-1 transition-transform duration-300 group-hover:translate-x-2">
                    {route?.from} to {route?.to}
                  </h3>
                  <p className="text-blue-200 text-sm transition-transform duration-300 group-hover:translate-x-2">
                    Starting at ₹{route?.fareStart?.toLocaleString('en-IN')}
                  </p>
                </div>
              </div>
              <div className="p-4">
                <button className="w-full py-2.5 bg-gradient-to-r from-purple-500 to-blue-500 hover:from-purple-600 hover:to-blue-600 text-white font-bold rounded-lg transition-all duration-300 btn-hover transform hover:scale-105">
                  Book Now
                </button>
              </div>
            </div>
          ))}
        </div>

        <div className="text-center mt-10 animate-fade-in">
          <button
            onClick={() => {
              navigate('/force-urbania');
              window.scrollTo(0, 0);
            }}
            className="inline-flex items-center gap-2 px-8 py-4 bg-gradient-to-r from-purple-600 to-blue-600 hover:from-purple-700 hover:to-blue-700 text-white font-bold rounded-full transition-all duration-300 shadow-lg hover:shadow-xl transform hover:scale-105 btn-hover"
          >
            <span>View All Routes</span>
            <Icon name="ArrowRight" size={20} />
          </button>
        </div>
      </div>
    </section>
  );
};

export default ForceUrbaniaRoutes;